import { DataBean } from "../../DataBean";


export class UpDepreciationParams extends DataBean {


    public async updateFixedAssetDepreciationParams(idLine:any,applyToAll:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateFixedAssetDepreciationParams_Number_Boolean", [idLine,applyToAll]);
    }


}